import { registerSW } from 'virtual:pwa-register';

import Elements from './elements/index.js';
import Libraries from './libraries/index.js';

/**
 * @typedef {Object} App
 * @property {string} title
 * @property {string} language
 * @property {string} direction
 */
export default {
  get title() {
    return document.title;
  },

  set title(title) {
    document.title = `${title} · ${import.meta.env.APP_NAME}`;
  },

  get language() {
    return document.documentElement.lang || import.meta.env.APP_LOCALE;
  },

  get direction() {
    return document.documentElement.dir || 'ltr';
  },

  async polyfill() {
    const polyfills = [];

    if (! ('popover' in HTMLElement.prototype)) {
      polyfills.push(import('@oddbird/popover-polyfill'));
    }

    if (! ('command' in HTMLButtonElement.prototype)) {
      polyfills.push(import('invokers-polyfill'));
    }

    return Promise.all(polyfills);
  },

  async install() {
    registerSW();

    await this.polyfill();

    Elements.install(this);
    Libraries.install(this);

    return this;
  },

};